import { AxiosError } from 'axios';
import { getNotificationStyle } from '../common/notification';
import { IFileUpload, IFileUploads } from '../model/CommonModel';
import { IAgreementProduct, IAgreementProofOfDelivery, IAgreementRateRangeListSaveRequest, IAgreementStationGroupListSaveRequest, IAgreementStationListSaveRequest, ICustomer, ICustomerAddress, IDemurrageAgreementItem, IDuplicateAgreementProduct, IEditAgreementProofOfDelivery, IIRSReport, IOdaPriceRequest, ISubAccountRequestList, ISubmitInvoice, IUpdateCustomerRequest } from "../model/CustomerModel";
import { UploadFormData, UploadRangeFormData } from '../stores/common';
import { IAgreementProductRangeGroupPriceRequest, IAgreementProductRequest, IAgreementProductStationGroupRequest, IAgreementProductStationRequest, IAgreementRateRangeRequest, IAgreementRequest, IUpdateAgreementStatus } from './../model/CustomerModel';
import AjexPortalService from "./api";
import config from "./config";

const customer = config.get('customer');
const customerAddress = config.get('customerAddress');
const customerSubAccount = config.get('customerSubAccount');
const customerBillingDetail = config.get('customerBillingDetail');
const fileType = config.get('fileType');
const fileTypeId = config.get('fileTypeId');
const agreement = config.get('agreement');
const clientId = config.get('clientId');
const agreementProduct = config.get('agreementProduct');
const getProduct = config.get('getProduct');
const createProduct = config.get('createProduct');
const agreementMasterAll = config.get('agreementMasterAll');
const master = config.get('master');
const agreementProductId = config.get('agreementProductId');
const agreementStationPrices = config.get('agreementStationPrices');
const agreementStationGroupPrices = config.get('agreementStationGroupPrices');
const agreementRateRange = config.get('agreementRateRange');
const updateAgreementStatus = config.get('updateAgreementStatus');
const download = config.get('download');
const upload = config.get('upload');
const customerAccountFile = config.get('customerAccountFile');
const downloadFile = config.get('downloadFile');
const clientSubId = config.get('clientSubId');
const uploadFile = config.get('uploadFile');
const exportToExcel = config.get('exportToExcel');
const submitForInvoicePath = config.get('submitForInvoicePath');
const manifest = config.get('manifest');
const agreementBillPeriod = config.get('agreementBillPeriod');
const fileAttachment = config.get('fileAttachment');
const all = config.get('all');
const pod = config.get('pod');
const podTypes = config.get('podTypes');
const duplicate = config.get('duplicate');
const bulk = config.get('bulk');
const getStationCountry = config.get('getStationCountry');
const getStationCountryId = config.get('getStationCountryId');
const city = config.get('city');
const country = config.get('country');
const agreementTracking = config.get('agreementTracking');
const byWaybill = config.get('byWaybill');
const updateInfo = config.get('updateInfo');
const agreementODAPrices = config.get('agreementODAPrices');
const subClientQuery = config.get('subClientQuery');
const customerAgreementIRSQuote = config.get('customerAgreementIRSQuote');
const createSubProduct = config.get('createSubProduct');
const performaReport = config.get('performaReport');
const enquiryQuotationId = config.get('enquiryQuotationId');
const costingSheetReport = config.get('costingSheetReport');
const salesPerson = config.get('salesPerson');
const bySalesPerson = config.get('bySalesPerson');
const demurrage = config.get('demurrage');


const tmsPricingService = process.env.REACT_APP_TMS_PRICING_SERVICE;
const reportURL = process.env.REACT_APP_TMS_REPORT_SERVICE;
const commonURL = process.env.REACT_APP_TMS_COMMON_SERVICE;

// When the request uses responseType: "blob", an error response body also
// arrives as a Blob instead of parsed JSON, so getNotificationStyle can't
// read its message. This unwraps the Blob back to JSON before notifying.
const notifyBlobError = async (response: any) => {
    if (response?.data instanceof Blob) {
        try {
            const text = await response.data.text();
            response = { ...response, data: JSON.parse(text) };
        } catch {
            // response body wasn't JSON; fall through with the original response
        }
    }
    getNotificationStyle(response);
};

export const SaveCustomerService = async (data: ICustomer) => {
    try {
        return await AjexPortalService.post(`${customer}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const SaveCustomerAddressService = async (data: ICustomerAddress) => {
    try {
        return await AjexPortalService.post(`${customerAddress}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateCustomerAddressService = async (data: ICustomerAddress, id: number) => {
    try {
        return await AjexPortalService.put(`${customerAddress}/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};



export const SaveCustomerBillingDetailsService = async (data: ICustomerAddress) => {
    try {
        return await AjexPortalService.post(`${customerBillingDetail}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const UpdateCustomerBillingDetailsService = async (data: ICustomerAddress, id: number) => {
    try {
        return await AjexPortalService.put(`${customerBillingDetail}/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveSubAccountService = async (data: ICustomerAddress) => {
    try {
        return await AjexPortalService.post(`${customerSubAccount}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};



export const GetCustomerByIdService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.get(`${customer}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const GetSubAccountAddressById = async (id: number) => {
    try {
        //customer-address/client_sub_id/17
        return await AjexPortalService.get(`${customerAddress}/client-id/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetSubAccountBillingAddressById = async (id: number) => {
    try {
        //customer-address/client_sub_id/17
        return await AjexPortalService.get(`${customerBillingDetail}/client-id/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const GetSubAccountAddressListById = async (id: number) => {
    try {
        //customer-address/client_sub_id/17
        return await AjexPortalService.get(`${customerAddress}/client_sub_id/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetSubAccountBillingAddressListById = async (id: number) => {
    try {
        //customer-address/client_sub_id/17
        return await AjexPortalService.get(`${customerBillingDetail}/sub-client-id/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const UpdateCustomerService = async (id: number, data: ICustomer) => {
    try {
        return await AjexPortalService.put(`${customer}/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const DeleteCustomerByIdService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${customer}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const FileTypeByIdService = async (id: number) => {
    try {
        //http://localhost:6200/api/v1/file-type/file-type-id/2
        return await AjexPortalService.get(`${fileType}/${fileTypeId}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAgreementListByIdService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreement}/${clientId}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveAgreementService = async (data: IAgreementRequest) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${agreement}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
//{{pricing}}/api/v1/agreement/duplicate/{agreementId}
export const DuplicateAgreementService = async (data: IAgreementRequest, agreementId?: number) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${agreement}/duplicate/${agreementId}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAgreementByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreement}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const SaveAgreementProductService = async (data: IAgreementProductRequest) => {
    try {
        //agreement-product/get-product/13
        return await AjexPortalService.post(`${tmsPricingService}${agreementProduct}/${createProduct}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAgreementProductListByIdService = async (id: number) => {
    try {
        //agreement-product/get-product/13
        return await AjexPortalService.get(`${tmsPricingService}${agreementProduct}/${getProduct}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAgreementProductByIdService = async (id: number) => {
    try {
        //agreement-product/get-product/13
        return await AjexPortalService.get(`${tmsPricingService}${agreementProduct}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const DeleteAgreementProductByService = async (id: number) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.delete(`${tmsPricingService}${agreementProduct}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAgreementMasterListService = async () => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.get(`${master}/${agreementMasterAll}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetStationsListByIdService = async (id: number, rangeId = null) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.get(
            `${tmsPricingService}${agreementStationPrices}/${agreementProductId}/${id}${rangeId ? `?agreementRangeId=${rangeId}` : ''}`
        );

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveAgreementProductStationService = async (data: IAgreementProductStationRequest) => {
    try {
        //agreement-station-prices
        return await AjexPortalService.post(`${tmsPricingService}${agreementStationPrices}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateAgreementProductStationService = async (data: IAgreementProductStationRequest, rowId: number | undefined) => {
    try {
        //agreement-station-prices
        return await AjexPortalService.put(`${tmsPricingService}${agreementStationPrices}/${rowId}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const DeleteAgreementProductStationByIdService = async (id: number) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.delete(`${tmsPricingService}${agreementStationPrices}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetStationsByIdService = async (id: number | undefined) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.get(`${tmsPricingService}${agreementStationPrices}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const GetStationsGroupListByIdService = async (id: number) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.get(`${tmsPricingService}${agreementStationGroupPrices}/${agreementProductId}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveAgreementProductStationGroupService = async (data: IAgreementProductStationGroupRequest) => {
    try {
        //agreement-station-prices
        return await AjexPortalService.post(`${tmsPricingService}${agreementStationGroupPrices}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const DeleteStationsGroupByIdService = async (id: number) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.delete(`${tmsPricingService}${agreementStationGroupPrices}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAgreementRateRangeListByIdService = async (id: number) => {
    try {
        //agreement-rate-range/
        return await AjexPortalService.get(`${tmsPricingService}${agreementRateRange}/${agreementProductId}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const GetAgreementRateRangeByIdService = async (id: number) => {
    try {
        //agreement-rate-range/
        return await AjexPortalService.get(`${tmsPricingService}${agreementRateRange}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveAgreementRateRangeService = async (data: IAgreementRateRangeRequest) => {
    try {
        //agreement-rate-range
        return await AjexPortalService.post(`${tmsPricingService}${agreementRateRange}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const UpdateAgreementRateRangeService = async (data: IAgreementRateRangeRequest, id: number) => {
    try {
        //agreement-rate-range
        return await AjexPortalService.put(`${tmsPricingService}${agreementRateRange}/${id}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteAgreementRangeRateByIdService = async (id: number) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.delete(`${tmsPricingService}${agreementRateRange}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateAgreementStatusService = async (data: IUpdateAgreementStatus, id: number) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.put(`${tmsPricingService}${agreement}/${updateAgreementStatus}/${id}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadStationFileService = async (id: number | undefined, isRange = false) => {
    try {
        let url = `${download}/AgreementStationPrices.xlsx`;
        if (isRange) {
            url = `${url}?agreementProductRangeId=true`;
        }
        return await AjexPortalService.get(url);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UploadStationFileService = async (file: any, id: number | undefined, range: number | undefined) => {
    try {
        const { formData, configuration } = UploadFormData(file)
        return await AjexPortalService.post(`${tmsPricingService}${agreementStationPrices}/${upload}/${id}/${range}`, formData, configuration)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const DownloadFileUploadService = async (id: number | undefined) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/customer-account-file/download-file/48
        return await AjexPortalService.get(`${customerAccountFile}/${downloadFile}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteFileUploadService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.delete(`${customerAccountFile}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const GetUploadedFileListService = async (subClientId: number) => {
    try {
        return await AjexPortalService.get(`${customerAccountFile}/${clientSubId}/${subClientId}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
};

export const UploadFilesService = async (fileObject: Partial<IFileUpload>) => {
    try {
        const { formData, configuration } = UploadFormData(fileObject)
        //customer-account-file/upload-file
        return await AjexPortalService.post(`${customerAccountFile}/${uploadFile}`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
}

export const UploadFileService = async (fileObject: IFileUploads) => {
    try {

        return await AjexPortalService.post(`${commonURL}${fileAttachment}/${upload}`, fileObject)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
}

export const DeleteAgreementByIdService = async (agreementId: number | undefined) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.delete(`${tmsPricingService}${agreement}/${agreementId}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const DownloadCustomerExcelFileService = async () => {
    try {
        return await AjexPortalService.get(`${reportURL}/${customer}/${download}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const ExportStationToExcelService = async (productId: number | undefined,) => {
    try {
        return await AjexPortalService.get(`${reportURL}/${agreementStationPrices}/${exportToExcel}/${productId}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const ExportStationGroupToExcelService = async (productId: number | undefined) => {
    try {
        return await AjexPortalService.get(`${reportURL}/${agreementStationGroupPrices}/${exportToExcel}/${productId}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const ExportRangeChargesToExcelService = async (productId: number | undefined) => {
    try {
        return await AjexPortalService.get(`${reportURL}/${agreementRateRange}/${exportToExcel}/${productId}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const SubmitForInvoiceService = async (request: ISubmitInvoice) => {
    try {
        return await AjexPortalService.put(`${commonURL}${manifest}/${all}/${submitForInvoicePath}`, request);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetAgreementBillPeriodService = async () => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreementBillPeriod}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAllPodTypesService = async (id: number) => {
    try {
        //(https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/pod/pod-types/1)
        return await AjexPortalService.get(`${tmsPricingService}${pod}/${podTypes}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetSubAccountByIdService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.get(`${customerSubAccount}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const UpdateSubAccountService = async (data: ISubAccountRequestList, id: number | undefined) => {
    try {
        return await AjexPortalService.put(`${customerSubAccount}/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/customer-sub-account/update-info/502
export const UpdateSubAccountSalesPersonService = async (data: Partial<ISubAccountRequestList>, id?: number) => {
    try {
        return await AjexPortalService.put(`${customerSubAccount}/update-info/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/customer-sub-account/494
export const GetCustomerSubAccountService = async (customerId?: number) => {
    try {
        return await AjexPortalService.get(`${customerSubAccount}/client-id/${customerId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/customer-sub-account/deactivate/557
export const DeleteSubAccountService = async (customerId?: number) => {
    try {
        return await AjexPortalService.put(`${customerSubAccount}/deactivate/${customerId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAllPodTypesByAgreementIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${pod}/${agreement}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const DeletePodTypesByAgreementIdService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${tmsPricingService}${pod}/${agreement}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const SavePodTypesForAgreementService = async (request: IAgreementProofOfDelivery) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${pod}/${agreement}`, request);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const EditPodTypesForAgreementByIdService = async (request: IEditAgreementProofOfDelivery) => {
    try {
        return await AjexPortalService.put(`${tmsPricingService}${pod}/${agreement}`, request);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const UpdateAgreementService = async (id?: number, data?: IAgreementRequest) => {
    try {
        return await AjexPortalService.put(`${tmsPricingService}${agreement}/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateAgreementProductService = async (id: number | undefined, data?: IAgreementProduct) => {
    try {
        return await AjexPortalService.put(`${tmsPricingService}${agreementProduct}/${createSubProduct}/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetUploadedIRSFilesService = async (subClientId: number) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/customer-agreement-irs-quote/sub-client-id/53
        return await AjexPortalService.get(`${commonURL}${customerAgreementIRSQuote}/${subClientQuery}/${subClientId}`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
};

export const UploadIRSFileService = async (fileObject: Partial<IFileUpload>) => {
    try {
        const { formData, configuration } = UploadFormData(fileObject)
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/customer-agreement-irs-quote/upload-file
        return await AjexPortalService.post(`${commonURL}${customerAgreementIRSQuote}/${uploadFile}`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
};

export const DownloadIRSFileService = async (quoteNo: number | undefined) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/customer-agreement-irs-quote/download-file/?quoteNo=IRQ00005
        return await AjexPortalService.get(`${commonURL}${customerAgreementIRSQuote}/${downloadFile}/?quoteNo=${quoteNo}`);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DuplicateAgreementProductService = async (data: IDuplicateAgreementProduct) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${agreementProduct}/${duplicate}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveAgreementStationListService = async (data: IAgreementStationListSaveRequest, productId: number | undefined) => {
    try {
        //agreement-station-prices
        return await AjexPortalService.post(`${tmsPricingService}${agreementStationPrices}/${bulk}/${productId}`, data);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const SaveAgreementStationGroupListService = async (data: IAgreementStationGroupListSaveRequest, productId: number | undefined) => {
    try {
        //agreement-station-prices
        return await AjexPortalService.post(`${tmsPricingService}${agreementStationGroupPrices}/${bulk}/${productId}`, data);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const SaveAgreementRangeRateListService = async (data: IAgreementRateRangeListSaveRequest, productId: number | undefined) => {
    try {
        //agreement-station-prices
        return await AjexPortalService.post(`${tmsPricingService}${agreementRateRange}/${bulk}/${productId}`, data);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

//https://apps.aj-ex.com/tms-booking-service/api/v1/country/get-station-country
export const GetStationCountryService = async () => {
    try {
        //agreement-station-prices
        return await AjexPortalService.get(`${country}/${getStationCountry}`);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetStationCityByCountryIdService = async (countryId: number | undefined) => {
    //https://apps.aj-ex.com/tms-booking-service/api/v1/city/get-station-country-id/16
    try {
        //agreement-station-prices
        return await AjexPortalService.get(`${city}/${getStationCountryId}/${countryId}`);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetTrackingByWayBillService = async (wayBill: string) => {
    try {
        return await AjexPortalService.get(`${reportURL}${agreementTracking}/${byWaybill}/${wayBill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/customer/update-info/442
export const UpdateCustomerInfoService = async (request: Partial<IUpdateCustomerRequest>, customerId: number) => {
    try {
        return await AjexPortalService.put(`${customer}/${updateInfo}/${customerId}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//https://apps-sit.aj-ex.com/tms-pricing-service/agreement-oda-prices/agreementProductId/1115
export const GetODAPriceService = async (id: number, rangeId = null) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreementODAPrices}/${agreementProductId}/${id}${rangeId ? `?agreementRangeId=${rangeId}` : ''}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//{{pricing}}/api/v1/agreement-oda-prices/download/1115
export const DownloadODAPriceService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${reportURL}/agreement-Oda-prices/${download}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//{{pricing}}/api/v1/agreement-oda-prices/upload/1115
export const UploadODAPriceService = async (fileObject: Partial<IFileUpload>, id: number, range: number) => {
    try {
        const { formData, configuration } = UploadFormData(fileObject)
        return await AjexPortalService.post(`${tmsPricingService}${agreementODAPrices}/${upload}/${id}/${range}`, formData, configuration);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

//{{report}}/api/v1/agreement-Oda-prices/export-to-excel/1115
export const ExportODAPriceToExcelService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${reportURL}/agreement-Oda-prices/${exportToExcel}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//{{pricing}}/api/v1/agreement-oda-prices
export const CreateODAPriceService = async (request: Partial<IOdaPriceRequest>) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${agreementODAPrices}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//{{pricing}}/api/v1/agreement-oda-prices/14
export const DeleteODAPriceService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${tmsPricingService}${agreementODAPrices}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

//{{pricing}}/api/v1/agreement-oda-prices/delete-oda-charges
export const ClearAllODAChargesService = async (agreementProductId: number) => {
    try {
        const payload = {
            agreementProductId,
            status: "deleteAll"
        };
        return await AjexPortalService.put(`${tmsPricingService}${agreementODAPrices}/delete-oda-charges`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

//http://localhost:6205/api/v1/report/download/performa-report?quotationId=2
export const DownloadPerformaFileService = async ({ enquiryQuotationId, manifestId }: IIRSReport) => {
    try {
        return await AjexPortalService.post(`${reportURL}report/download/${performaReport}?enquiryQuotationId=${enquiryQuotationId}&manifestId=${manifestId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

//http://localhost:6205/api/v1/report/download/costing-sheet-report?quotationId=2
export const DownloadCostingSheetFileService = async ({ enquiryQuotationId, manifestId }: IIRSReport) => {
    try {
        return await AjexPortalService.post(`${reportURL}report/download/${costingSheetReport}?enquiryQuotationId=${enquiryQuotationId}&manifestId=${manifestId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

// http://localhost:6240/api/v1/agreement-station-range/agreement-product
// /{agreementProductId}
export const GetProductRangebyProductIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}agreement-station-range/agreement-product/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

// http://localhost:6240/api/v1/agreement-station-range'
export const AddProductRangebyProductIdService = async (payload) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}agreement-station-range`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

// http://localhost:6240/api/v1/agreement-product-ranges/bulk/1971'
export const AddInternationalRangeService = async (payload, id) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}agreement-product-ranges`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

//https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-product-ranges/agreement-product/1978
export const GetInternationalRangeService = async (id) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}agreement-product-ranges/agreement-product/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const GetRangeStationsListByIdService = async (rangeId) => {
    try {
        // http://localhost:6240/api/v1/agreement-product-range-station-prices/agreement-product-range/244
        return await AjexPortalService.get(`${tmsPricingService}agreement-product-range-station-prices/agreement-product-range/${rangeId}`
        );

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const CreateRangeStationService = async (req, rangeId) => {
    try {
        // http://localhost:6240/api/v1/agreement-product-range-station-prices/bulk/244
        return await AjexPortalService.post(`${tmsPricingService}agreement-product-range-station-prices/bulk/${rangeId}`, req);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};



export const UpdateRangeStationService = async (req) => {
    try {
        // http://localhost:6240/api/v1/agreement-product-range-station-prices/bulk/244
        return await AjexPortalService.put(`${tmsPricingService}agreement-product-range-station-prices/${req?.id}`, req);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const DeleteRangeStationService = async (id) => {
    try {
        // http://localhost:6240/api/v1/agreement-product-range-station-prices/450
        return await AjexPortalService.delete(`${tmsPricingService}agreement-product-range-station-prices/${id}`);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetRangeStationsByIdService = async (id: number | undefined) => {
    try {
        //master/agreement-master-all
        return await AjexPortalService.get(`${tmsPricingService}agreement-product-range-station-prices/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}


export const UploadRangeStationFileService = async (file: any, id: number | undefined, range: number | undefined) => {
    try {
        const { formData, configuration } = UploadRangeFormData(file)
        return await AjexPortalService.post(`${tmsPricingService}agreement-product-range-station-prices/upload/${id}/${range}`, formData, configuration)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const AddDRERangeRateService = async (req) => {
    try {
        // https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-product-range-price
        return await AjexPortalService.post(`${tmsPricingService}agreement-product-range-price`, req);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetDRERangeRateListService = async (RangeId) => {
    try {
        // https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-product-range-price/agreementProductRangeId/379
        return await AjexPortalService.get(`${tmsPricingService}agreement-product-range-price/agreementProductRangeId/${RangeId}`);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateDRERangeRateService = async (req) => {
    try {
        // https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-product-range-price/3
        return await AjexPortalService.put(`${tmsPricingService}agreement-product-range-price/${req?.id}`, req);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const AddRangeGroupPriceService = async (req: IAgreementProductRangeGroupPriceRequest) => {
    try {
        // https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-product-range-group-prices
        return await AjexPortalService.post(`${tmsPricingService}agreement-product-range-group-prices`, req);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateRangeGroupPriceService = async (req: IAgreementProductRangeGroupPriceRequest) => {
    try {
        // https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-product-range-group-prices/3
        return await AjexPortalService.put(`${tmsPricingService}agreement-product-range-group-prices/${req?.id}`, req);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetRangeGroupPriceListService = async (rangeId: number) => {
    try {
        // https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-product-range-group-prices/agreement-product-range/712
        return await AjexPortalService.get(`${tmsPricingService}agreement-product-range-group-prices/agreement-product-range/${rangeId}`);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteRangeGroupPriceService = async (id: number) => {
    try {
        // https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-product-range-group-prices/3
        return await AjexPortalService.delete(`${tmsPricingService}agreement-product-range-group-prices/${id}`);

    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const GetAgreementRateRangeStationByProductIdService = async (productId: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}agreement-rate-range-station/agreementProductId/${productId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

// https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/agreement-rate-range-station/bulk/2413
export const SaveAgreementRateRangeStationBulkService = async (req: {
    agreementProductId: number;
    agreementRateRangeDtoList: Array<{
        agreementProductUnitId: number;
        from: string;
        to?: string;
        fractionVal: string;
        rate: string;
        orgCountryId: number;
        destCountryId: number;
        orgCityId: number;
        destCityId: number;
    }>;
}) => {
    try {
        return await AjexPortalService.post(
            `${tmsPricingService}/agreement-rate-range-station/bulk/${req.agreementProductId}`,
            req
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteAgreementRateRangeStationByIdService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${tmsPricingService}agreement-rate-range-station/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAgreementRateRangeStationByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}agreement-rate-range-station/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateAgreementRateRangeStationService = async (req: {
    id: number;
    agreementProductId: number;
    agreementProductUnitId: number;
    agreementProductUnit: string;
    from: number;
    to: number;
    fractionVal: number;
    rate: number;
    orgCountryId: number;
    destCountryId: number;
    orgCityId: number;
    destCityId: number;
}) => {
    try {
        return await AjexPortalService.put(
            `${tmsPricingService}agreement-rate-range-station/${req.id}`,
            req
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadAgreementExcelService = async (
    params?: {
        mainAccount?: string;
        subAccount?: string;
        startDate?: string;
        endDate?: string;
    }
) => {
    try {
        return await AjexPortalService.get(
            `${tmsPricingService}excel/download/agreement`,
            // `https://apps-sit.aj-ex.com/tms-pricing-service/api/excel/download/agreement`,
            {
                params,
                responseType: "blob",
            }
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UploadAgreementExcelService = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
        return await AjexPortalService.post(
            `${tmsPricingService}/agreement-upload/upload`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadExtraChargeAgreementExcelService = async (
    params?: {
        mainAccount?: string;
        subAccount?: string;
    }
) => {
    try {
        return await AjexPortalService.get(
            `${tmsPricingService}excel/download/agreement/v2`,
            {
                params,
                responseType: "blob",
            }
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        await notifyBlobError(err?.response);
        return err?.response;
    }
};

export const UploadExtraChargeAgreementExcelService = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
        return await AjexPortalService.post(
            `${tmsPricingService}agreement-upload/upload/v2`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        await notifyBlobError(err?.response);
        return err?.response;
    }
};


export const UpdateCustomerSalesPersonService = async (customerId: number, salesPersonId: number) => {
    try {
        return await AjexPortalService.put(`${customer}/update/${salesPerson}/${customerId}/${salesPersonId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetCustomersBySalesPersonService = async (salesPersonId: number) => {
    try {
        //customer/by-sales-person/{salesPersonId}
        return await AjexPortalService.get(`${customer}/${bySalesPerson}/${salesPersonId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const CreateBulkAgreementService = async () => {
    try {
        return await AjexPortalService.post(
            `${tmsPricingService}agreement/gpi-create-bulk-agreement-additional-charges`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const ActivateBulkAgreementService = async () => {
    try {
        return await AjexPortalService.post(
            `${tmsPricingService}agreement/gpi-active-bulk-agreement-additional-charges`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetDemurrageMasterService = async () => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${demurrage}/${master}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetDemurrageAgreementService = async (agreementId: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${demurrage}/${agreement}?agreementId=${agreementId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveDemurrageAgreementService = async (data: IDemurrageAgreementItem[]) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${demurrage}/${agreement}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};




